import { HttpMethod } from '@libs/core';

import type { CategoryEditorInterface, CategoryJob, CategoryJobIdResponse } from '@/types';

const prepareCategoryFormData = (values: CategoryEditorInterface): FormData => {
    const formData = new FormData();

    formData.append('action', values.action);
    formData.append('categoryKey', values.categoryKey);

    if (values.webStyleIDsFile) {
        let file: Blob;

        if (values.webStyleIDsFile instanceof Blob || values.webStyleIDsFile instanceof File) {
            file = values.webStyleIDsFile;
        } else {
            file = new Blob([], { type: 'text/csv' });
        }

        const fileName: string | undefined =
            'name' in values.webStyleIDsFile ? (values.webStyleIDsFile.name as string) : undefined;

        formData.append('webStyleIDsFile', file, fileName);
    }

    return formData;
};

export const fetchCategoryJobById = async (jobId: string): Promise<CategoryJob | null> => {
    try {
        const response = await fetch(`/api/categoryJobs/${jobId}`);

        if (!response.ok) {
            throw new Error(`Failed to fetch job ${jobId}`);
        }

        const { data } = await response.json();
        return data;
    } catch (err) {
        console.error(`Failed to fetch job ${jobId}`, err);

        return null;
    }
};

export const submitCategory = async (values: CategoryEditorInterface): Promise<CategoryJobIdResponse | null> => {
    try {
        const formData = prepareCategoryFormData(values);

        const response = await fetch(`/api/categoryJobs`, {
            method: HttpMethod.POST,
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`Failed to submit Category`);
        }

        const { data } = await response.json();
        return data;
    } catch (err) {
        console.error('Failed to submit Category', err);

        return null;
    }
};

export const fetchCategoryJobs = async (requestor?: string): Promise<CategoryJob[]> => {
    try {
        const response = await fetch(
            `/api/categoryJobs${requestor ? `?requestor=${encodeURIComponent(requestor)}` : ''}`
        );

        if (!response.ok) {
            console.error(`Failed to fetch category jobs for requestor: ${requestor}`);
            return [];
        }

        const { data } = await response.json();
        return data;
    } catch (err) {
        console.error('Error fetching category jobs by requestor:', err);
        return [];
    }
};
